import React, { useEffect, useState } from "react";
import { project } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { language } from "../../../system/types/project/language";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import { LanguageSelector } from "../../FormElements/LanguageSelector";
import { ProjectApi } from "../../../system/api/ProjectApi";
import { useTranslations } from "../../../hooks/useTranslations";

const EditLanguage = () => {

    const { t } = useTranslations();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);

    const [projectId, setProjectId] = useState<string>('');
    const [commandId, setCommandId] = useState<string>('');

    const [editLanguage, setEditLanguage] = useState<language>({
        name: '',
        isoCode: '',
        lang: '',
    });

    const [excludeList, setExcludeList] = useState<string[]>([]);

    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
        if (state.project.pageCommandId !== commandId) {
            setCommandId(state.project.pageCommandId);
        }

    });

    const changeEditLanguage = (language: language) => {
        setEditLanguage(language);
    }

    const save = async () => {

        if (editLanguage.isoCode === '') {
            return;
        }

        const newList:language[] = [];

        projectData.languages.forEach((language) => {
            if (language.isoCode === commandId) {
                newList.push(editLanguage);
                return;
            }
            newList.push(language);
        });

        if (commandId === '') {
            newList.push(editLanguage);
        }

        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.saveProjectLanguages(projectId, newList);

        if (result._id) {
            dispatch(actions.project.setData(result))
            dispatch(actions.project.setPageCommand(''));
        }
    };

    const deleteEntry = async () => {

        const userConfirmed = window.confirm('soll die Sprache aus der Liste entfernt werden?');
        
        if (!userConfirmed){
            return;
        }

        const newList:language[] = [];

        projectData.languages.forEach((language) => {
            if (language.isoCode === commandId) {
                return;
            }
            newList.push(language);
        });


        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.saveProjectLanguages(projectId, newList);

        if (result._id) {
            dispatch(actions.project.setData(result))
            dispatch(actions.project.setPageCommand(''));
        }

    };

    const cancel = () => {
        dispatch(actions.project.setPageCommand(''));
    };

    useEffect(() => {

        const list: string[] = [];

        list.push(projectData.baseLanguage.isoCode);

        projectData.languages.forEach((language) => {
            if (language.isoCode === commandId) {
                setEditLanguage(language);
                return;
            }
            list.push(language.isoCode);
        });
        setExcludeList(list);

    }, [projectData, commandId]);


    return (<div className="container-float px-3 py-3">
        <div className="row mb-3 align-items-center">
            <div className="col"><h2>{editLanguage.isoCode === '' ? t('projects.addlanguage') : editLanguage.name} &nbsp;</h2></div>
            <div className="col-auto"><button onClick={save} className="btn btn-outline-success">{t('common.save')}</button></div>
            {commandId !== '' ?
                <div className="col-auto"><button onClick={deleteEntry} className="btn btn-outline-danger">{t('common.delete')}</button></div>
                : null}
            <div className="col-auto"><button onClick={cancel} className="btn btn-outline-danger">{t('common.cancel')}</button></div>
        </div>
        <div className="row mb-3">
            <div className="col">
                <LanguageSelector 
                    name="defaultLanguage" 
                    value={editLanguage} 
                    label={t('projects.language')}
                    onChange={changeEditLanguage}
                    excluded={excludeList}
                    ></LanguageSelector>
            </div>
        </div>

    </div>);
}

export { EditLanguage };
